module.exports = __webpack_public_path__ + "img/metajuana-curation-room.ea23b2d3.png";